import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "Tti" */ "./lazyIndex"), {
    name: "Tti",
});
export const lazyGovern: LazyAction<typeof lazyIndex.govern, typeof lazyModule> = new LazyAction(lazyModule, m => m.govern);
export const lazyEnableGovernReport: LazyAction<typeof lazyIndex.enableGovernReport, typeof lazyModule> = new LazyAction(lazyModule, m => m.enableGovernReport);
